/**
 * Feature flags gobernados por variables de entorno (Vite).
 *
 * Mastershop se controla con VITE_ENABLED_MASTERSHOP.
 * Por defecto está OFF: si la env no es exactamente "true", Mastershop queda
 * oculto en toda la app (panel de integraciones, finanzas, etc.), como si la
 * integración no existiera.
 */
export const isMastershopEnabled = (): boolean =>
  import.meta.env.VITE_ENABLED_MASTERSHOP === "true";
